import { combineReducers } from '@reduxjs/toolkit';
import userMenuReducer from './userMenuStore';
import authenticationReducer from './authenticationStore';
import alertHandlerReducer from './alertStore';
// import themeReducer from "./themeStore";

const reducers = combineReducers({
  userMenu: userMenuReducer,
  authentication: authenticationReducer,
  alertHandler: alertHandlerReducer,
  // toggleTheme: themeReducer
});

export default reducers;
export type RootState = ReturnType<typeof reducers>;
